/**
 * Defines all the capabilities
 */
const ALL_CAPABILITIES = [
	'Conditions',
	'Events',
	'Export',
	'Inspections',
	'Ratings',
	'Rehab',
	'Risk',
	'RiskScore',
	'Tasks',
	'Upload',
] as const;

/**
 * Typescript trick to get the types only defined once.
 */
type CapabilityTuple = typeof ALL_CAPABILITIES;

/**
 * Represents the different capabilities that an asset or property can have.
 */
export type Capability = CapabilityTuple[number];

/**
 * List of all capabilities.
 */
export const Capabilities: readonly Capability[] = ALL_CAPABILITIES;

/**
 * Represents the different types of inspections.
 * @see {@link InspectionsStandards}:w
 * @deprecated Use `InspectionsStandards` instead.:w
 */
export type InspectionTypes = 'MACP' | 'PACP' | 'MSCC' | 'WSA05';
/**
 * Represents the different types of inspections.
 */
export type InspectionsStandards = InspectionTypes;

/**
 * Represents a risk category with its display name and associated capabilities.
 */
export interface RiskCategory {
	DisplayName: string;
	Condition?: boolean;
	Cof?: boolean;
	Lof?: boolean;
}
